var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2269 15.9559C15.6409 16.3699 16.2799 15.7309 15.8659 15.3259L12.4911 11.9422C13.6749 10.6323 14.3293 8.92904 14.327 7.16351C14.327 3.21278 11.1142 0 7.16351 0C3.21278 0 0 3.21278 0 7.16351C0 11.1142 3.21278 14.327 7.16351 14.327C8.94538 14.327 10.5923 13.6701 11.8522 12.5811L15.2269 15.9559ZM0.899038 7.16351C0.899038 3.70774 3.71584 0.899938 7.16261 0.899938C10.6184 0.899938 13.4262 3.70774 13.4262 7.16351C13.4262 10.6193 10.6184 13.4271 7.16261 13.4271C3.71584 13.4271 0.899038 10.6193 0.899038 7.16351Z",
    fill: "#8B8989"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.fbf95d05d1da43f321ada3213c7392ee.svg";
export { ForwardRef as ReactComponent };